import { Grid, Typography } from "@mui/material";
import { Hive as HiveIcon } from "@mui/icons-material";
import React from "react";

export default function Hive({ center }) {
  return (
    <Grid
      container
      justifyContent={center ? "center" : "left"}
      style={{ marginLeft: -5 }}
    >
      <HiveIcon style={{ marginRight: 5, color: "orange" }} />
      <Typography style={{ color: "black", fontWeight: 600 }}>Tak</Typography>
    </Grid>
  );
}
